export const FETCH_STORE = 'Store/FETCH_STORE'
export const FETCH_STORE_SUCCESS = 'Store/FETCH_STORE_SUCCESS'
export const FETCH_STORE_ERROR = 'Store/FETCH_STORE_ERROR'
export const FETCH_STORE_DONE = 'Store/FETCH_STORE_DONE'
